var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      attrs: {
        color: _vm.color,
        bottom: _vm.bottom,
        top: _vm.top,
        left: _vm.left,
        right: _vm.right,
        centered: _vm.centered,
        shaped: "",
      },
      model: {
        value: _vm.snackbar,
        callback: function ($$v) {
          _vm.snackbar = $$v
        },
        expression: "snackbar",
      },
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "11" } },
            [
              _c("v-alert", { attrs: { type: _vm.alertType } }, [
                _vm._v(_vm._s(_vm.message)),
              ]),
            ],
            1
          ),
          _c(
            "v-col",
            { staticStyle: { "text-align": "center" }, attrs: { cols: "1" } },
            [
              _c(
                "div",
                {
                  staticStyle: { "font-size": "22px" },
                  style: { cursor: "pointer" },
                  on: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v("x")]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }